import { render, staticRenderFns } from "./FullScreenModal.vue?vue&type=template&id=b49acf48&scoped=true&"
import script from "./FullScreenModal.vue?vue&type=script&lang=js&"
export * from "./FullScreenModal.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenModal.vue?vue&type=style&index=0&id=b49acf48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49acf48",
  null
  
)

export default component.exports